import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('vercel'),
  avatarPath: avatars.vercel,
  logoPath: logos.vercel
});
